import { saveState } from 'utils';

const persistFilters = (data, item, persistKey, findCallback) => {
  const hasItem = data.find(findCallback);

  if (!hasItem) {
    const newData = [...data, item];
    saveState(persistKey, newData);
    return newData;
  }
  const idx = data.findIndex(findCallback);

  const newData = [...data.slice(0, idx), ...data.slice(idx + 1)];
  saveState(persistKey, newData);

  return newData;
};

export default persistFilters;
